import React from 'react';
import { Interpolate } from 'react-i18next';
import styles from './sub-title.scss';

import { Text } from 'wix-style-react';

const SubTitle = () => (
  <div
    data-hook="mi-facebook-catalog-link-sub-title"
    className={styles.container}
  >
    <Text secondary>
      <Interpolate
        i18nKey="facebook-catalog.modal.subtitle"
        useDangerouslySetInnerHTML
      />
    </Text>
  </div>
);

export default SubTitle;
